<div class="page-error-wrapper">
  <div>
    <div class="text-center mb-4"> <img src="assets/alert.png"> </div>

    <h1 class="error-title">Page Not Found</h1>
    <h5 class="error-subtitle">Oopps. The page you were looking for doesn't exist.</h5>
    <p class="mb-5">You may have mistyped the address or the page may have moved.</p>
    <p class="mb-5"><a (click)="back()" [routerLink]="" class="btn btn-error">
        Back to Previous Page
      </a></p>
    <p class="mb-5"><a routerLink="/" class="btn btn-primary">
        Go to Home
      </a></p>
    <p class="error-footer p-2">&copy; Copyright {{today| date: 'yyyy'}}. All Rights Reserved.</p>
  </div>
</div>
